/**
 * Created by Ethan on 2017/9/8.
 */

import * as ActionTypes from '../constants/ActionTypes'

import {RoutePath} from '../constants/RoutePath';
import {CACHE_SESSION_USER} from "../constants/Profile";
import MenuItem from "../entity/MenuItem";

export function getDefaultLanguage() {

    /*
     *获取浏览器设置的语言；
     *按我demo中的设置，返回["zh-CN", "zh", "en-US", "en"]，排序与语言设置顺序一直；
     */
    const languages = navigator.languages;
    const defaultLanguage = "zh-CN";
    //console.log("languages: ", languages);
    //console.log("language: ", defaultLanguage);
    return {
        type: ActionTypes.APP_GET_DEFAULT_LANGUAGE,
        currentLanguage: defaultLanguage
    }
}

export function changeLanguage(language) {
    return dispatch => {
        dispatch({
            type: ActionTypes.APP_CHANGE_LANGUAGE,
            currentLanguage: language
        })
    }
}

export function getMainMenu() {

    let menuItems = [];
    let menuItemMap = {};


    // 用户个人中心
    const menuAccountUser = RoutePath.ACCOUNT_USER_CENTER;
    menuAccountUser.children = [];
    menuItems.push(menuAccountUser);
    menuItemMap[menuAccountUser.path] = menuAccountUser;
    // 个人信息
    const menuAccountProfile = RoutePath.ACCOUNT_USER_PROFILE;
    menuItemMap[menuAccountProfile.path] = menuAccountProfile;
    // 增加到用户个人中心菜单中
    menuAccountUser.children.push(menuAccountProfile);

    return {
        type: ActionTypes.APP_GET_MAIN_MENU,
        menuItems: menuItems,
        menuItemMap: menuItemMap
    }
}